import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "ledningaendring",
  "use": "ledningaendring-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" id=\"ledningaendring\"><path d=\"M1.5 22.45h2.27s-.43-8.79 7.16-10.21h7.79s1.63-.14 1.7-1.56 0-2.55 0-2.55h-1.91V5.86h10V8h-2.14l-.14 3.61S26 17.88 20 17.91h-8.51a2.75 2.75 0 0 0-1.77 2.2c-.14 1.63-.21 2.34-.21 2.34h2.05v2H1.5z\" fill=\"#6d6e71\" stroke=\"#6d6e71\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\".43\" /><circle cx=\"21.63\" cy=\"15.15\" r=\"6.88\" fill=\"#da9c28\" /><path d=\"M21.63 14V9.15l2.4 2.4zm0 7.2l-2.4-2.4 2.4-2.4zm3-9a4.2 4.2 0 0 1-3 7.17v-1.2a3 3 0 0 0 3-3 3 3 0 0 0-.88-2.17zm-3-1.23v1.2a3 3 0 0 0-2.12 5.12l-.84.85a4.15 4.15 0 0 1-1.24-3 4.2 4.2 0 0 1 4.2-4.2z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/ledningaendring.svg
// module id = eKnh
// module chunks = 1